module.exports = __webpack_public_path__ + "static/img/6.ad9ce13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/su/6.jpg
// module id = eAig
// module chunks = 1